import { useMutation } from '@tanstack/react-query';
import { getAxios } from '../axios';
import { apiRoutes } from '../../constants/apiRoutes';

export function useSetProfileMutation() {
  return useMutation({
    mutationFn: async (profileId: number) => {
      await getAxios().post(apiRoutes.auth.profiles.setActive(profileId));
    }
  });
}
